export default [
    {
        question: "What project are you working on?",
        answers: [
            {
                title: "Shed or Fence",
                image: "301_Shed-Fence.jpg",
                question: "Is your shed or fence currently treated with anything?",
                answers: [
                    {
                        title: "New and uncoated",
                        image: "302_Shed-Fence_Uncoated.jpg",
                        question: "Do you need a wood preserving primer?",
                        answers: [
                            {
                                title: "Yes",
                                image: "304_Shed-Fence_With_Primer.jpg",
                                products: [
                                    {
                                        handle: "wood-preserver-primer"
                                    }
                                ]
                            },
                            {
                                title: "No",
                                image: "305_Shed-Fence_Without_Primer.jpg",
                                question: "What is your desired finish?",
                                answers: [
                                    {
                                        title: "Clear",
                                        image: "306_Shed-Fence_Natural_Protector.jpg",
                                        products: [
                                            {
                                                handle: "water-sealer",
                                            },
                                            {
                                                handle: "wood-protector",
                                                variant: "42428513517726"
                                            } 
                                        ]
                                    },
                                    {
                                        title: "Semi-transparent wood stain",
                                        image: "307_Shed-Fence_Semi-Transparent.jpg",
                                        products: [
                                            {
                                                handle: "shed-fence-protector",
                                            },
                                            {
                                                handle: "wood-protector"
                                            }
                                        ]
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        title: "An existing wood stain",
                        image: "303_Shed-Fence_Coated.jpg",
                        question: "What is your desired finish?",
                        answers: [
                            {
                                title: "Semi-transparent wood stain",
                                image: "307_Shed-Fence_Semi-Transparent.jpg",
                                products: [
                                    {
                                        handle: "shed-fence-protector"
                                    },
                                    {
                                        handle: "wood-protector"
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                title: "Outdoor Furniture",
                image: "101_Furniture.jpg",
                question: "Does your outdoor furniture already have a coating?",
                answers: [
                    {
                        title: "New and uncoated",
                        image: "102_Furniture_Uncoated.jpg",
                        question: "Do you need a wood preserving primer?",
                        answers: [
                            {
                                title: "Yes",
                                image: "104_Furniture_With_Primer.jpg",
                                products: [
                                    {
                                        handle: "wood-preserver-primer"
                                    }
                                ]
                            },
                            {
                                title: "No",
                                image: "105_Furniture_Without_Primer.jpg",
                                question: "What is your desired finish?",
                                answers: [
                                    {
                                        title: "Clear",
                                        image: "107_Furniture_Natural_Protector.jpg",
                                        products: [
                                            {
                                                handle: "water-sealer",
                                            },
                                            {
                                                handle: "wood-protector",
                                                variant: "42428513517726"
                                            },
                                        ]
                                    },
                                    {
                                        title: "Semi-transparent wood stain",
                                        image: "106_Furniture_Semi-Transparent.jpg",
                                        products: [
                                            {
                                                handle: "wood-protector"
                                            }
                                        ]
                                    },
                                ]
                            }
                        ]
                    },
                    {
                        title: "An existing wood stain",
                        image: "103_Furniture_Coated.jpg",
                        question: "What is your desired finish?",
                        answers: [
                            {
                                title: "Semi-transparent wood stain",
                                image: "106_Furniture_Semi-Transparent.jpg",
                                products: [
                                    {
                                        handle: "wood-protector"
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                title: "Planter",
                image: "201_Planter.jpg",
                question: "Is your planter currently treated with anything?",
                answers: [
                    {
                        title: "New and uncoated",
                        image: "202_Planter_Uncoated.jpg",
                        question: "What is your desired finish?",
                        answers: [
                            {
                                title: "Clear",
                                image: "204_Planter_Natural_Protector.jpg",
                                products: [
                                    {
                                        handle: "wood-protector",
                                        variant: "42428513517726"
                                    }
                                ]
                            },
                            {
                                title: "Semi-transparent wood stain",
                                image: "205_Planter_Semi-Transparent.jpg",
                                products: [
                                    {
                                        handle: "wood-protector"
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        title: "An existing wood stain",
                        image: "203_Planter_Coated.jpg",
                        question: "What is your desired finish?",
                        answers: [
                            {
                                title: "Semi-transparent wood stain",
                                image: "205_Planter_Semi-Transparent.jpg",
                                products: [
                                    {
                                        handle: "wood-protector"
                                    }
                                ]
                            },
                        ]
                    },
                ]
            },
            {
                title: "Decking",
                image: "01_Decking.jpg",
                question: "Is your decking already stained?",
                answers: [
                    {
                        title: "No",
                        image: "02_Decking_Uncoated.jpg",
                        question: "What end result do you want for your decking?",
                        answers: [
                            {
                                title: "Natural",
                                image: "06_Decking_Natural_Protector.jpg",
                                products: [
                                    {
                                        handle: "decking-protector",
                                        variant: "42408279736478"
                                    }
                                ]
                            },
                            {
                                title: "Semi-transparent stain",
                                image: "07_Decking_Semi-Transparent.jpg",
                                question: "What shade do you want for your decking?",
                                answers: [
                                    {
                                        title: "Light",
                                        image: "04_Decking_Light_Stain.jpg",
                                        products: [
                                            {
                                                handle: "decking-protector",
                                                variant: "42408279769246"
                                            }
                                        ]
                                    },
                                    {
                                        title: "Dark",
                                        image: "05_Decking_Dark_Stain.jpg",
                                        products: [
                                            {
                                                handle: "decking-protector",
                                                variant: "42408279802014"
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        title: "Yes",
                        image: "03_Decking_Coated.jpg",
                        question: "What shade do you want for your decking?",
                        answers: [
                            {
                                title: "Light",
                                image: "04_Decking_Light_Stain.jpg",
                                products: [
                                    {
                                        handle: "decking-protector",
                                        variant: "42408279769246"
                                    }
                                ]
                            },
                            {
                                title: "Dark",
                                image: "05_Decking_Dark_Stain.jpg",
                                products: [
                                    {
                                        handle: "decking-protector",
                                        variant: "42408279802014"
                                    }
                                ]
                            }
                        ]
                    }
                ]            
            }
        ]
    }
]